import angular from 'angular'
import template from './template.html'

angular.module('nominas.informacionfiscal')
  .component('nominasInformacionfiscalEmpresasEmpresaDescarga', {
    template: template,
    controller: Component,
    require: {
      parent: '^nominasInformacionfiscalEmpresasEmpresa',
    },
  });

function Component($file, $zip) {
  let $ctrl = this,
    max = 5;

  $ctrl.$onInit = $onInit;
  $ctrl.agregar = agregar;
  $ctrl.cancelar = cancelar;
  $ctrl.descargar = descargar;
  $ctrl.reintentar = reintentar;

  function $onInit() {
    $ctrl.completado = false;
    $ctrl.completados = 0;
    $ctrl.data = $ctrl.parent.data.reverse();
    $ctrl.documentos = [];
    $ctrl.error = null;
    $ctrl.generando = false;
    $ctrl.lista = [];
    $ctrl.omitidos = 0;
    $ctrl.pendientes = [].concat($ctrl.data);
    $ctrl.progreso = 0;
    $ctrl.status = 'Inicializando';
    $ctrl.total = $ctrl.pendientes.length;
    $ctrl.zip = null;
    $ctrl.archivoNombre = $ctrl.parent.empresa.Nombre + ' - ' +
      'Información Fiscal ' + $ctrl.parent.ejercicio + '-' + $ctrl.parent.periodo;

    avanzar();
  }

  function agregar(item, data) {
    if (!data)
      $ctrl.omitidos++;

    if (!data)
      $ctrl.error = item;

    $ctrl.documentos.push(data);
    avanzar();
  }

  function avanzar() {
    $ctrl.completados = $ctrl.documentos.reduce(function (prev, next) {
      return prev + (next ? 1 : 0);
    }, 0);

    $ctrl.progreso = Math.round(($ctrl.completados / $ctrl.total) * 100);
    $ctrl.status = $ctrl.completados + ' de ' + $ctrl.total + ' documentos procesados';

    if ($ctrl.total === $ctrl.completados)
      return comprimir();

    if ($ctrl.error)
      return;

    if (!$ctrl.pendientes.length || ($ctrl.lista.length - $ctrl.documentos.length) >= max)
      return;

    $ctrl.lista.push($ctrl.pendientes.shift());
    $ctrl.generando = true;
    $ctrl.completado = false;

    avanzar();
  }

  function cancelar() {
    $ctrl.onClose();
  }

  function comprimir() {
    $ctrl.generando = false;
    $ctrl.comprimiendo = true;

    let documentos = $ctrl.documentos.filter(function (item) {
      return item;
    });

    $zip().then(function (zip) {
      documentos.forEach(function (document) {
        zip.file(document.name, document.content)
      });

      return zip
        .generateAsync({type: 'blob', compression: 'DEFLATE', mimeType: 'application/zip'})
        .then(function (content) {
          $ctrl.zip = content;
        });
    }).finally(function () {
      $ctrl.comprimiendo = false;
      $ctrl.completado = true;
    });
  }

  function descargar() {
    $file.saveAs($ctrl.zip, $ctrl.archivoNombre);
  }

  function reintentar() {
    /*$ctrl.documentos = $ctrl.documentos.filter(function (item, index) {
     if (!item)
     $ctrl.pendientes.shift($ctrl.data[index]);

     return item
     });

     $ctrl.error = null;*/
  }
}



// WEBPACK FOOTER //
// ./src/nominas/informacionfiscal/components/empresas/empresa/descarga/component.js